import React, { useEffect, useCallback, useRef, useMemo } from "react";
import styles from "./index.module.less";
import { Carousel, message as toast } from "antd";
import { FocusSDK } from "@/utils";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { genThirdAppUrl } from "@/components/ThirdApp";
import { formate } from "@/utils/date";

function BannerCard(props: any) {
  // 卡片高度与移动端保持一致  宽高比为 9:5
  let cardH = `${Math.ceil(330 / 1.8)}px`;
  const { message } = props;
  const { authInfo, appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);
  const isPrivateNet = useRef<boolean>(FocusSDK.isPrivateNet());

  const bannerList = useMemo(() => {
    return message?.data || [];
  }, [message?.data]);

  // 点击查看详情
  const handleClickLink = useCallback(
    (data: any) => {
      if (!data) {
        return;
      }
      const { applicationKey, deeplink, linkUrlEgov, linkUrl } = data;
      const url = deeplink ? deeplink : isPrivateNet.current ? linkUrlEgov : linkUrl;
      let realUrl = "";
      const parseUrl = DeeplinkEvent.parseDeeplink(url);
      if (parseUrl) {
        if (parseUrl.pathname && parseUrl.pathname.includes("browser")) {
          const mparam = parseUrl.mparam || {};
          realUrl = isPrivateNet.current ? mparam.egovUrl : mparam.url;
        } else {
          DeeplinkEvent.open(url);
        }
      }
      if (!realUrl) {
        realUrl = isPrivateNet.current ? linkUrlEgov : linkUrl;
      }
      if (!realUrl) {
        toast.warn("该应用不支持在当前网络环境下打开");
        return;
      }
      if (applicationKey) {
        realUrl = genThirdAppUrl(
          applicationKey,
          authInfo.ddAppId,
          authInfo.accessToken,
          appRuntimeEnv,
          {
            redirectUrl: realUrl
          }
        );
      }
      window.open(realUrl);
    },
    [appRuntimeEnv, authInfo?.accessToken, authInfo?.ddAppId]
  );

  return (
    <div className={styles["banner-wrap"]}>
      {bannerList.length > 0 ? (
        <Carousel autoplay style={{ height: "100%", width: "100%" }}>
          {bannerList.map((item: any) => {
            return (
              <div
                key={item.id}
                data-url={item.linkUrl}
                className={styles["slide-wrap"]}
                onClick={(e) => {
                  e.stopPropagation();
                  handleClickLink(item);
                }}
              >
                <div
                  className={styles["img"]}
                  style={{
                    backgroundImage: `url(${item?.imgUrl})`,
                    height: cardH
                  }}
                >
                  <div className={styles["news-title"]}>{item?.title}</div>
                  <p className={styles["news-date"]}>{formate(item.startTime, true)}</p>
                </div>
              </div>
            );
          })}
        </Carousel>
      ) : (
        <div className={styles["no-data"]}>
          <div>暂无数据</div>
        </div>
      )}
    </div>
  );
}

export default BannerCard;
